import ClientStorage from './ClientStorage';

export default ClientStorage;
export { default as storageAvailable } from './storageAvailable';
export { default as TransientClientStorage } from './TransientClientStorage';
